<script>
import Loader from "@/components/_base/Loader";

export default {
  components: {
    Loader
  }
};
</script>

<template>
  <div class="root">
    <Loader  />
    <p>Buscando os seus endereços...</p>
  </div>
</template>

<style scoped>
.root {
  width: calc(100% - 24px - 24px);
  padding: 16px 12px;
  margin: 4px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #424242;
  background: #fff;
  cursor: pointer;
}
p {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Loader.vue